import {
    allFetch,
    ResultObj
} from "../Domain";
import { searchSettings } from "../types";

/**
 * @description 使用者剩餘請假天數查詢(特休專用) (參數)
 * @param year 年資
 * @param user_ids 帳號編號們
 * @param company_id 公司流水號
 * @param general_manager_id 高階管理階層（前總經理室）流水號
 * @param department_id 部門流水號
 * @param position_id 據點流水號
 * @param class_id 課級流水號
 * @param group_id 組級流水號
 * @param office_id 辦公室流水號
 * @param page 頁碼
 * @param num_per_page 一頁幾筆
 */

export interface LeaveRemainAnnualSearchParams {
    year: string,
    [searchSettings.user_ids]: string[];
    [searchSettings.company_id]: string;
    [searchSettings.general_manager_id]: string;
    [searchSettings.department_id]: string;
    [searchSettings.position_id]: string;
    [searchSettings.class_id]: string;
    [searchSettings.group_id]: string;
    [searchSettings.office_id]: string;
    page: number,
    num_per_page: number,
}
/**
 * @description 使用者剩餘請假天數查詢(特休專用) (回傳)
 */
export interface LeaveRemainAnnualSearchResItem {
    day_get: string;
    day_remain: string;
    lra_id: string;
    minute_get: string;
    minute_remain: string;
    name: string;
    user_cre_time: string;
    user_id: string;
    year: string;
}
/**
 * @description 使用者剩餘請假天數查詢(特休專用)
 */
export const LeaveRemainAnnualSearch =
    async (obj: LeaveRemainAnnualSearchParams = {
        year: '',
        user_ids: [],
        company_id: '',
        general_manager_id: '',
        department_id: '',
        position_id: '',
        class_id: '',
        group_id: '',
        office_id: '',
        page: 1,
        num_per_page: 10
    }): Promise<ResultObj<LeaveRemainAnnualSearchResItem[]>> => await allFetch('Leave/LeaveRemainAnnualSearch', obj);



/**
* @description 使用者剩餘請假天數查詢(特休除外) (參數)
* @param year 年資
* @param leave_rule_no_annual_id 假別流水號
* @param date_start 日期起(8)
* @param date_end 日期迄(8)
* @param user_ids 帳號編號們
* @param company_id 公司流水號
* @param general_manager_id 高階管理階層（前總經理室）流水號
* @param department_id 部門流水號
* @param position_id 據點流水號
* @param class_id 課級流水號
* @param group_id 組級流水號
* @param office_id 辦公室流水號
* @param page 頁碼
* @param num_per_page 一頁幾筆
*/

export interface LeaveRemainNoAnnualSearchParams {
    year: number | string;
    leave_rule_no_annual_id: string;
    date_start: string;
    date_end: string;
    [searchSettings.user_ids]: string[];
    [searchSettings.company_id]: string;
    [searchSettings.general_manager_id]: string;
    [searchSettings.department_id]: string;
    [searchSettings.position_id]: string;
    [searchSettings.class_id]: string;
    [searchSettings.group_id]: string;
    [searchSettings.office_id]: string;
    page: number,
    num_per_page: number,
}
/**
 * @description 使用者剩餘請假天數查詢(特休除外) (回傳)
 */
export interface LeaveRemainNoAnnualSearchResItem {
    date_end: string;
    date_start: string;
    day_get: string;
    day_remain: string;
    divisible: string;
    key_date: string;
    leave_rule_no_annual_code: string;
    leave_rule_no_annual_id: string;
    leave_rule_no_annual_name: string;
    leave_type: string;
    lrna_id: string;
    minute_get: string;
    minute_remain: string;
    name: string;
    user_cre_time: string;
    user_id: string;
    year: string;
}
/**
 * @description 使用者剩餘請假天數查詢(特休除外)
 */
export const LeaveRemainNoAnnualSearch =
    async (obj: LeaveRemainNoAnnualSearchParams = {
        year: 0,
        leave_rule_no_annual_id: '',
        date_start: '',
        date_end: '',
        user_ids: [],
        company_id: '',
        general_manager_id: '',
        department_id: '',
        position_id: '',
        class_id: '',
        group_id: '',
        office_id: '',
        page: 1,
        num_per_page: 10
    }): Promise<ResultObj<LeaveRemainNoAnnualSearchResItem[]>> => await allFetch('Leave/LeaveRemainNoAnnualSearch', obj);



/**
* @description 使用者剩餘請假天數修改(特休專用) (參數)
* @param user_id 帳號編號
* @param year 年資
* @param day_get 得到天數
* @param day_remain 剩餘天數
*/

export interface LeaveRemainAnnualUpdateParams {
    user_id: string,
    year: string,
    day_get: string,
    day_remain: string
}

/**
 * @description 使用者剩餘請假天數修改(特休專用)
 */
export const LeaveRemainAnnualUpdate =
    async (obj: LeaveRemainAnnualUpdateParams = {
        user_id: '',
        year: '',
        day_get: '',
        day_remain: ''
    }): Promise<ResultObj> => await allFetch('Leave/LeaveRemainAnnualUpdate', obj);


/**
* @description 假別查詢(特休天數規則查詢)(回傳)
*/
export interface LeaveRuleAnnualSearchResItem {
    basic_day: number;
    date_end: string;
    date_start: string;
    leave_rule_annual_id: number;
    year: number;
}
/**
 * @description 假別查詢(特休天數規則查詢)
 */
export const LeaveRuleAnnualSearch =
    async (obj = {
    }): Promise<ResultObj<LeaveRuleAnnualSearchResItem[]>> => await allFetch('Leave/LeaveRuleAnnualSearch', obj);


/**
* @description 請假申請查詢(參數)
*/
export interface LeaveRecordSearchParams {
    leave_record_id: string;
    leave_rule_no_annual_id: string;
    date_start: string;
    date_end: string;
    statuses: string[];
    [searchSettings.user_ids]: string[];
    [searchSettings.company_id]: string;
    [searchSettings.general_manager_id]: string;
    [searchSettings.department_id]: string;
    [searchSettings.position_id]: string;
    [searchSettings.class_id]: string;
    [searchSettings.group_id]: string;
    [searchSettings.office_id]: string;
    page: number;
    num_per_page: number;
}
/**
* @description 請假申請查詢(回傳)
*/
export interface LeaveRecordSearchResItem {
    audit_level: string;
    cre_time: string;
    day_next_year: number;
    day_this_year: number;
    is_full_day_end: string;
    is_full_day_start: string;
    key_date: string;
    leave_date_end: string;
    leave_date_start: string;
    leave_record_id: string;
    leave_rule_no_annual_code: string;
    leave_rule_no_annual_id: string;
    leave_rule_no_annual_name: string;
    leave_time_end: string;
    leave_time_start: string;
    leave_type: string;
    minute_next_year: number;
    minute_this_year: number;
    name: string;
    note: string;
    proxy_name: string;
    proxy_user_cre_time: string;
    status: string;
    user_cre_time: string;
    user_id: string;
    year_next: number;
    year_this: number;
}
/**
 * @description 請假申請查詢
 */
export const LeaveRecordSearch =
    async (obj: LeaveRecordSearchParams
    ): Promise<ResultObj<LeaveRecordSearchResItem[]>> =>
        await allFetch('Leave/LeaveRecordSearch', obj);


/**
* @description 銷假申請建立(參數)
*/
export interface LeaveRecordCancelCreateParams {
    leave_record_id: string,
    note: string
}
/**
 * @description 銷假申請建立
 */
export const LeaveRecordCancelCreate =
    async (obj: LeaveRecordCancelCreateParams):
        Promise<ResultObj<LeaveRuleAnnualSearchResItem[]>> =>
        await allFetch('Leave/LeaveRecordCancelCreate', obj);



/**
* @description 請假申請建立(參數)
*/
export interface LeaveRecordCreateParams {
    HttpFileCollection: FormData,
    LeaveRecordCreate: string //LeaveRecordCreateDetail
}

/**
* @description 請假申請建立(詳細參數)
*/
export interface LeaveRecordCreateDetail {
    user_id: string,
    leave_rule_no_annual_id: string,
    leave_type: string,
    leave_date_start: string,
    leave_date_end: string,
    is_full_day_start: string,
    is_full_day_end: string,
    leave_time_start: string,
    leave_time_end: string,
    key_date: string,
    note: string,
    proxy_user_id: string,
}
/**
 * @description 請假申請建立
 */
export const LeaveRecordCreate =
    async (obj: FormData):
        Promise<ResultObj<LeaveRuleAnnualSearchResItem[]>> =>
        await allFetch<FormData>('Leave/LeaveRecordCreate', obj);



/**
* @description 使用者剩餘請假天數查詢(某一人當年度特休剩餘天數、請假時看的)(參數)
* @param user_id 帳號編號
*/
export interface LeaveRemainAnnualSearchOwnParams {
    user_id: string,
}

export interface LeaveRemainAnnualSearchOwnResItem {
    day_get: number;
    day_remain: number;
    minute_get: number;
    minute_remain: number;
    year: number;
}
/**
 * @description 使用者剩餘請假天數查詢(某一人當年度特休剩餘天數、請假時看的)
 */
export const LeaveRemainAnnualSearchOwn =
    async (obj: LeaveRemainAnnualSearchOwnParams = {
        user_id: '',
    }): Promise<ResultObj<LeaveRemainAnnualSearchOwnResItem[]>> => await allFetch('Leave/LeaveRemainAnnualSearchOwn', obj);


/**
* @description 使用者剩餘請假天數查詢(某一人還能用的補休分鐘數、請假時看的)(參數)
* @param user_id 帳號編號
*/
export interface LeaveRemainCompensateSearchOwnParams {
    user_id: string,
}

export interface LeaveRemainCompensateSearchOwnResItem {
    minute_get: number,
    minute_remain: number
}
/**
 * @description 使用者剩餘請假天數查詢(某一人還能用的補休分鐘數、請假時看的)
 */
export const LeaveRemainCompensateSearchOwn =
    async (obj: LeaveRemainCompensateSearchOwnParams = {
        user_id: '',
    }): Promise<ResultObj<LeaveRemainCompensateSearchOwnResItem[]>> => await allFetch('Leave/LeaveRemainCompensateSearchOwn', obj);


/**
* @description 假別查詢(參數)
* @param leave_rule_no_annual_id 流水號
* @param visible 是否可見
* @param user_id 帳號編號
*/
export interface LeaveRuleNoAnnualSearchParams {
    leave_rule_no_annual_id: string,
    visible: string,
    user_id: string,
}

export interface LeaveRuleNoAnnualSearchResItem {
    basic_day: number;
    deadline_note: string;
    divisible: string;
    document_note: string;
    few_days_after: number;
    few_days_before: number;
    leave_rule_no_annual_code: string;
    leave_rule_no_annual_id: string;
    leave_rule_no_annual_name: string;
    leave_type: string;
    min_unit_num: number;
    min_unit_type: string;
    need_document: string;
    visible: string;
}
/**
 * @description 假別查詢
 */
export const LeaveRuleNoAnnualSearch =
    async (obj: LeaveRuleNoAnnualSearchParams = {
        leave_rule_no_annual_id: '',
        visible: '',
        user_id: ''
    }): Promise<ResultObj<LeaveRuleNoAnnualSearchResItem[]>> => await allFetch('Leave/LeaveRuleNoAnnualSearch', obj);


/**
* @description 假別查詢(參數)
* @param leave_rule_no_annual_id 流水號
* @param visible 是否可見
* @param user_id 帳號編號
*/
export interface LeaveRuleNoAnnualUpdateParams {
    basic_day: number;
    deadline_note: string;
    divisible: string;
    document_note: string;
    few_days_after: number;
    few_days_before: number;
    leave_rule_no_annual_id: string;
    min_unit_num: number;
    min_unit_type: string;
    need_document: string;
    visible: string;
}

export interface LeaveRuleNoAnnualUpdateResItem {
    basic_day: number;
    deadline_note: string;
    divisible: string;
    document_note: string;
    few_days_after: number;
    few_days_before: number;
    leave_rule_no_annual_code: string;
    leave_rule_no_annual_id: string;
    leave_rule_no_annual_name: string;
    leave_type: string;
    min_unit_num: number;
    min_unit_type: string;
    need_document: string;
    visible: string;
}
/**
 * @description 假別查詢
 */
export const LeaveRuleNoAnnualUpdate =
    async (obj: LeaveRuleNoAnnualUpdateParams = {
        leave_rule_no_annual_id: '',
        min_unit_type: '',
        min_unit_num: 0,
        basic_day: 0,
        few_days_before: 0,
        few_days_after: 0,
        divisible: '',
        need_document: '',
        deadline_note: '',
        document_note: '',
        visible: ''
    }): Promise<ResultObj<LeaveRuleNoAnnualUpdateResItem[]>> => await allFetch('Leave/LeaveRuleNoAnnualUpdate', obj);


/**
 * @description 銷假申請審核(參數)
 * @param leave_record_id 假單編號
 * @param status 審核狀態
 * @param note 備註
 */
export interface LeaveRecordCancelAuditParams {
    leave_record_id: string,
    status: string,
    note: string
}
/**
 * @description 銷假申請審核
 */
export const LeaveRecordCancelAudit =
    async (obj: LeaveRecordCancelAuditParams = {
        leave_record_id: '',
        status: '',
        note: ''
    }): Promise<ResultObj> => await allFetch('Leave/LeaveRecordCancelAudit', obj);

/**
* @description 請假申請審核(參數)
* @param leave_record_id 假單編號
* @param status 審核狀態
* @param note 備註
*/
export interface LeaveRecordAuditParams {
    leave_record_id: string,
    status: string,
    note: string
}
/**
 * @description 請假申請審核
 */
export const LeaveRecordAudit =
    async (obj: LeaveRecordAuditParams = {
        leave_record_id: '',
        status: '',
        note: ''
    }): Promise<ResultObj> => await allFetch('Leave/LeaveRecordAudit', obj);


/**
* @description 剩餘有薪休假天數統計 (參數)
* @param date_start 到期日期起
* @param date_end 到期日期迄
* @param user_ids 帳號編號們
* @param company_id 公司流水號
* @param general_manager_id 高階管理階層（前總經理室）流水號
* @param department_id 部門流水號
* @param position_id 據點流水號
* @param class_id 課級流水號
* @param group_id 組級流水號
* @param office_id 辦公室流水號
* @param excel 是否匯出
*/
export interface LeaveRemainStatisticParams {
    date_start: string,
    date_end: string,
    [searchSettings.user_ids]: string[];
    [searchSettings.company_id]: string;
    [searchSettings.general_manager_id]: string;
    [searchSettings.department_id]: string;
    [searchSettings.position_id]: string;
    [searchSettings.class_id]: string;
    [searchSettings.group_id]: string;
    [searchSettings.office_id]: string;
    disable: "Y" | "N" | ""; //  帳號狀態
    isresign: "Y" | "N" | ""; //  是否離職
    excel: string,
    page: number,
    num_per_page: number,
}
/**@description 剩餘有薪休假天數統計 (回傳) */
export interface LeaveRemainStatisticResItem {
    annual_detail: {
        day_remain_sum: number,
        minute_remain_sum: number,
        lrsa_detail: {
            date_end: string;
            date_get: string;
            day_get: number;
            day_remain: number;
            lra_id: string;
            minute_get: number;
            minute_remain: number;
            year: string;
        }[],
    },
    compensate_rest_detail: {
        minute_remain_sum: number,
        lrscr_detail: {
            lrna_id: string;
            minute_get: number;
            minute_remain: number;
            date_end: string;
            lrsow_detail: {
                date_get: string;
                minute_get: number;
            }[];
        }[],
    }


    name: string,
    on_board_date: string,
    user_id: string,
    username: string,
}
/**
 * @description 剩餘有薪休假天數統計
 */
export const LeaveRemainStatistic =
    async (obj: LeaveRemainStatisticParams = {
        date_start: '',
        date_end: '',
        user_ids: [],
        company_id: '',
        general_manager_id: '',
        department_id: '',
        position_id: '',
        class_id: '',
        group_id: '',
        office_id: '',
        disable: "",
        isresign: "",
        excel: '',
        page: 1,
        num_per_page: 10,
    }): Promise<ResultObj<LeaveRemainStatisticResItem[]>> => await allFetch('Leave/LeaveRemainStatistic', obj);




/**@description 剩餘特休補休天數結算 (參數) */
export interface LeaveRemainSettleParams {
    lra_ids: string[],
    lrna_ids: string[],
}
/**
 * @description 剩餘特休補休天數結算
 */
export const LeaveRemainSettle =
    async (obj: LeaveRemainSettleParams = {
        lra_ids: [],
        lrna_ids: []
    }): Promise<ResultObj> => await allFetch('Leave/LeaveRemainSettle', obj);




/**@description 剩餘特休補休天數結算紀錄查詢 (參數) */
export interface LeaveRemainSettleLogSearchParams {
    date_start: string,
    date_end: string,
    page: number,
    num_per_page: number
}

/**@description 剩餘特休補休天數結算紀錄查詢 (回傳) */
export interface LeaveRemainSettleLogSearchResItem {
    content: string;
    cre_time: string;
    cre_userid: string;
    id: number;
    name: string;
    user_cre_time: string;
    username: string;
}
/**
 * @description 剩餘特休補休天數結算紀錄查詢
 */
export const LeaveRemainSettleLogSearch =
    async (obj: LeaveRemainSettleLogSearchParams = {
        date_start: '',
        date_end: '',
        page: 1,
        num_per_page: 10
    }): Promise<ResultObj<LeaveRemainSettleLogSearchResItem[]>> => await allFetch('Leave/LeaveRemainSettleLogSearch', obj);


/**@description 剩餘特休補休天數結算紀錄細項 (參數) */
export interface LeaveRemainSettleLogDetailParams {
    id: string;
}
/**@description 剩餘特休補休天數結算紀錄細項 (回傳) */
export interface LeaveRemainSettleLogDetailResItem {
    content: string;
    cre_time: string;
    cre_userid: string;
    id: number;
    name: string;
    user_cre_time: string;
    username: string;
}
/**
 * @description 剩餘特休補休天數結算紀錄細項
 */
export const LeaveRemainSettleLogDetail =
    async (obj: LeaveRemainSettleLogDetailParams = {
        id: ''
    }): Promise<ResultObj<LeaveRemainSettleLogDetailResItem[]>> => await allFetch('Leave/LeaveRemainSettleLogDetail', obj);


